import * as angular from 'angular';
import { Constants as constants } from '@constants/shared';
import { TradingRepo as tradingRepo } from '@services/trading.repo';
import { trading } from './trading';
import { portfolioTradeSets } from './portfoliotradesets/portfolioTradeSets';
import { tradeValidity } from './portfoliotradesets/tradeValidity.modal';
import { tradeSheets } from './tradesheets/tradesheets';
import { cancelTradeSheetDialog } from '../tradingadmin/tradesheets/cancelTradeSheetDialog/cancelTradeSheet.dialog';
import { TradeValidatiesTable } from './portfoliotradesets/tradeValidatiesTable.component';


export const tradingModule = 'trading';

angular
  .module(tradingModule, ['xeditable', 'ngMaterial', 'angularModalService'])
  .constant("config", constants.Default)
  .service('tradingRepo', tradingRepo)
  .component('trading', trading)
  .component('tradeSheets', tradeSheets)
  .component('tradeValidity', tradeValidity)
  .component('tradeValidatiesTable', TradeValidatiesTable)
  .component('portfolioTradeSets', portfolioTradeSets)
  .component('cancelTradeSheetDialog2', cancelTradeSheetDialog)



// WEBPACK FOOTER //
// ./src/app/trading/trading.index.ts